// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__1e41Y","separator":"Breadcrumbs_separator__2ImnP","menu-container":"Breadcrumbs_menu-container__2VfzG"};